import { v4 as uuid } from 'uuid';

import type { Route, Passengers, GetSearchPayloadParams } from '../types';
import type { MappedLocation } from '../../../shared/types';

const createRoute = ({ dep, arr, dates = [] }: Partial<Route> = {}) => ({
  id: uuid(),
  dep,
  arr,
  dates,
});

const buildInitialRoutes = (routes: Array<Partial<Route>>) =>
  routes.map(route => createRoute(route));

const getBackendCode = (location: MappedLocation): string =>
  ('codeForBackend' in location ? location.codeForBackend : undefined) ??
  location.code;

const getRoutePayload = ({ dep, arr, dates }: Route) => ({
  dep: getBackendCode(dep),
  arr: getBackendCode(arr),
  date: dates[0],
});

const buildReturnRoutePayload = ({ dep, arr, dates }: Route) => ({
  dep: getBackendCode(arr),
  arr: getBackendCode(dep),
  date: dates[1],
});

const getItinerariesPayload = (routes: Array<Route>) =>
  routes.flatMap(route => {
    const OWRoutePayload = getRoutePayload(route);
    return route.dates.length > 1
      ? [OWRoutePayload, buildReturnRoutePayload(route)]
      : OWRoutePayload;
  });

const getPassengersStatePayload = (
  passengers: Passengers,
  isYouth: boolean,
) => {
  /* eslint-disable-next-line object-curly-newline */
  const { adt, chd, inf, yth } = passengers;
  return {
    adt: isYouth ? 0 : adt,
    chd: isYouth ? 0 : chd,
    inf: isYouth ? 0 : inf,
    yth: isYouth ? yth : 0,
  };
};

function getSearchFormPayload({
  routes,
  passengers,
  cabinClass,
  isYouth,
}: GetSearchPayloadParams) {
  return {
    itineraries: getItinerariesPayload(routes),
    passengers: getPassengersStatePayload(passengers, isYouth),
    cabinClass,
  };
}

export const payloadLib = {
  getSearchFormPayload,
  buildInitialRoutes,
  createRoute,
};
